<template>
  <ul v-if="isLoading">
    <li
      v-for="(_, i) in Array(numberToLoad)"
      :key="i"
      class="d-flex align-center justify-space-between pt-3"
    >
      <div
        class="d-flex pl-2"
        style="width: 470px; max-width: 100%; height: 50px;"
      >
        <v-skeleton-loader
          :loading="false"
          :type="isRequisition ? 'list-item' : 'list-item-avatar-two-line'"
          width="100%"
          height="50px"
          class="left-side-loader"
        />
      </div>
      <div class="d-flex align-center justify-center">
        <div class="right-section pl-16">
          <v-skeleton-loader
            :loading="false"
            type="text"
            height="13px"
            width="58px"
          />
        </div>
        <div class="right-section">
          <v-skeleton-loader
            :loading="false"
            type="text"
            width="50"
            height="13"
          />
        </div>
        <div
          v-if="isRequisition"
          class="right-section"
        >
          <v-skeleton-loader
            :loading="false"
            type="text"
            width="145"
            height="13"
          />
        </div>
        <div
          v-if="showThreeDotsMenu"
          class="three-dots-menu"
        >
          <v-icon size="small" icon="$dots-vertical" />
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  numberToLoad: {
    type: Number,
    default: 9,
  },
  isRequisition: {
    type: Boolean,
    default: false,
  },
  showThreeDotsMenu: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="less" scoped>
ul {
  list-style-type: none;
  background: @white;
  border-radius: 8px;
  overflow: hidden;
  padding-bottom: 12px;
}

.right-section {
  padding: 0 24px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.left-side-loader :deep(.v-skeleton-loader__list-item-avatar-two-line) {
  height: 50px;
  align-items: flex-start;
}

.left-side-loader :deep(.v-skeleton-loader__avatar) {
  height: 50px;
  min-height: 50px;
  max-height: 50px;
  width: 50px;
  min-width: 50px;
  max-height: 50px;
  margin: 0px 16px;
}

.left-side-loader :deep(.v-skeleton-loader__text) {
  &:nth-child(1) {
    margin: 10px 16px 8px 16px;
  }

  &:nth-child(2) {
    margin: 0px 16px 8px 16px;
  }
}

.right-section :deep(.v-skeleton-loader__text) {
  margin: 0px;
}

.three-dots-menu {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  :deep(.v-icon) path {
    fill: @skeleton;
  }
}
</style>
